import { DongtienService } from 'src/services/dongtien.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const DONGTIEN_NEW_CARE_SUCCESS = 'DONGTIEN:NEW_CARE_SUCCESS'
export const DONGTIEN_LIST_SUCCESS = 'DONGTIEN:FIND_ALL_SUCCESS'
export const DONGTIEN_LIST_FAILD = 'DONGTIEN:FIND_ALL_FAILD'
export const DONGTIEN_COUNT_ASSIGN_SUCCESS = 'DONGTIEN:COUNT_ASSIGN_SUCCESS'
export const DONGTIEN_COUNT_ASSIGN_FAILD = 'DONGTIEN:COUNT_ASSIGN_FAILD'

export const DONGTIEN_CREATE_SUCCESS = 'DONGTIEN:CREATE_SUCCESS'
export const DONGTIEN_CREATE_FAILD = 'DONGTIEN:CREATE_FAILD'

export const DONGTIEN_IMPORT_SUCCESS = 'DONGTIEN:IMPORT_SUCCESS'
export const DONGTIEN_SAVE_SUCCESS = 'DONGTIEN:SAVE_SUCCESS'
export const DONGTIEN_SAVE_FAILD = 'DONGTIEN:SAVE_SUCCESS'

export const DONGTIEN_DEL_SUCCESS = 'DONGTIEN:DEL_SUCCESS'
export const DONGTIEN_DEL_FAILD = 'DONGTIEN:DEL_FAILD'

export const DONGTIEN_ONE_SUCCESS = 'DONGTIEN:FIND_ONE_SUCCESS'
export const DONGTIEN_ONE_FAILD = 'DONGTIEN:FIND_ONE_FAILD'

export const DONGTIEN_HISTORY_LIST_SUCCESS = 'DONGTIEN:HISTORY_FIND_ALL_SUCCESS'
export const DONGTIEN_HISTORY_LIST_FAILD = 'DONGTIEN:HISTORY_FIND_ALL_FAILD'

export const DONGTIEN_UPDATE_FILTER = 'DONGTIEN:UPDATE_FILTER'

export const DongtienAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,
}

function updateFilter(payload) {
    return { type: DONGTIEN_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            DongtienService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(DongtienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: DONGTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            DongtienService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(DongtienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: DONGTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        DongtienService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONGTIEN_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { dongtien } = getState()
        dispatch(AppAction.appLoading(true));
        DongtienService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...dongtien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONGTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            const { dongtien } = getState();
            const page = dongtien && typeof dongtien.filter !== 'undefined' && dongtien.filter && typeof dongtien.filter.page !== 'undefined' ? dongtien.filter.page : 0;
            const limit = dongtien && typeof dongtien.filter !== 'undefined' && dongtien.filter && typeof dongtien.filter.limit !== 'undefined' ? dongtien.filter.limit : 10;
            DongtienService.findAll(page, limit, dongtien.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                        tong_hoa_hong: rs.data.tong_hoa_hong,
                        cong_so_du: rs.data.cong_so_du,
                        tru_so_du: rs.data.tru_so_du,
                        tru_so_du_don_nap: rs.data.tru_so_du_don_nap,
                        hoan_tien_that_bai_don: rs.data.hoan_tien_that_bai_don,
                    }));
                } else {
                    const oldItems = dongtien.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                        tong_hoa_hong: rs.data.tong_hoa_hong,
                        cong_so_du: rs.data.cong_so_du,
                        tru_so_du: rs.data.tru_so_du,
                        tru_so_du_don_nap: rs.data.tru_so_du_don_nap,
                        hoan_tien_that_bai_don: rs.data.hoan_tien_that_bai_don,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: DONGTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: DONGTIEN_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            DongtienService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(DongtienAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: DONGTIEN_SAVE_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            DongtienService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(DongtienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: DONGTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        DongtienService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(DongtienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONGTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        DongtienService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(DongtienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONGTIEN_DEL_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        DongtienService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONGTIEN_ONE_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        DongtienService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(DongtienAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { dongtien } = getState()
        dispatch(AppAction.appLoading(true));
        DongtienService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...dongtien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONGTIEN_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONGTIEN_HISTORY_LIST_FAILD, error } }
}